module.exports = __webpack_public_path__ + "img/product4.e3b8c4d2.png";